import { DateTimePicker } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import { useState } from 'react'

interface SurgeryDateProps {
  value: Dayjs | string | null
  onChange: (value: Dayjs | null) => void
  showLabel?: boolean
  size?: 'small' | 'medium'
}

const SurgeryDate: React.FC<SurgeryDateProps> = ({
  value,
  onChange,
  showLabel = true,
  size = 'medium'
}) => {
  const [openPicker, setOpenPicker] = useState<boolean>(false)

  return (
    <DateTimePicker
      label={showLabel ? 'Data e hora da cirurgia' : undefined}
      value={typeof value === 'string' ? dayjs(value) : value}
      onChange={onChange}
      open={openPicker}
      onOpen={() => setOpenPicker(true)}
      onClose={() => setOpenPicker(false)}
      sx={{
        width: '100%',
        backgroundColor: 'var(--input-background)'
      }}
      slotProps={{
        textField: {
          size,
          onClick: () => setOpenPicker(true),
          placeholder: showLabel ? undefined : 'Data e hora da cirurgia',
          inputProps: {
            readOnly: true
          }
        },
        inputAdornment: {
          position: 'start',
          sx: {
            color: 'primarySoft.main'
          }
        }
      }}
    />
  )
}

export default SurgeryDate
